export enum DeprecatedEvents {
  // Deprecated in favor of IP_TYPE
  IP_MDNS = 'ip.mdns',
  // Deprecated in favor of WEBSOCKET_CONNECT
  WEBSOCKET_CONNECTION = 'websocket.connect'
}
